var copy=  {
    exec: (id) => {
        var element = document.getElementById(id);
        if (document.body.createTextRange) {
            range = document.body.createTextRange();
            range.moveToElementText(element);
            range.select();
        } else if (window.getSelection) {
            selection = window.getSelection();
            range = document.createRange();
            range.selectNodeContents(element);
            selection.removeAllRanges();
            selection.addRange(range);
        }
        try {
            var text = element.innerText || element.textContent;
            // Clean up spaces, newlines, tabs at start/end
            text = text.trim();
            // Modern API first
            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(text);
                return true;
            } else {
                // Fallback for older browsers
                var textarea = document.createElement("textarea");
                textarea.value = text;
                document.body.appendChild(textarea);
                textarea.select();
                document.execCommand("copy");
                document.body.removeChild(textarea);
                return true;
            }
        } catch (err) {
            console.error('unable to copy text');
            return false;
        }
    }
}
